import { useCallback } from "react";
import type { AgentSimpleResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const useFormatUserWithType = () => {
	const { t } = useResource();

	return useCallback(
		(user: Pick<AgentSimpleResponseDTO, "name" | "type">): string =>
			`${user.name} (${t(Resources.Dashboard.UserType[user.type])})`,
		[t],
	);
};
